const labelMapper = {
  b: "B",
  kb: "kB",
  Mb: "MB",
  Gb: "GB"
};
const getUnitTextLabel = (abbrev) => {
  var _a;
  return (_a = labelMapper[abbrev]) != null ? _a : abbrev;
};
export default getUnitTextLabel;
